module.exports = __webpack_public_path__ + "static/media/morning_coffee.9faa97d8.jpg";